import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import settings from 'services/app-settings';

const authOptions: OktaAuthOptions = {
  issuer: settings.okta.issuer,
  clientId: settings.okta.clientID,
  redirectUri: settings.okta.redirectUri,
  postLogoutRedirectUri: settings.okta.postLogoutRedirectUri,
  tokenManager: {
    autoRenew: true,
    secure: true,
  },
  pkce: true,
};

const oktaAuth = new OktaAuth(authOptions);

export function useOktaAuth(): OktaAuth {
  return oktaAuth;
}
